import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol } from '@angular/common';

@Pipe({
  name: 'dkCurrency',
})
export class DkCurrencyPipe implements PipeTransform {
  transform(value: number | string | null, currencyCode = 'kr.', digitsInfo = '1.2-2', locale = 'da-DK'): string | null {
    if (value == null) {
      return null;
    }

    if (typeof value === 'string') {
      value = Number(value);
    }

    return formatCurrency(value, locale, getCurrencySymbol(currencyCode, 'wide'), currencyCode, digitsInfo);
  }
}
